export function touchAll(selectors, cb, scope) {
    if (scope === void 0) { scope = document; }
    var elements = [];
    for (var _i = 0, selectors_1 = selectors; _i < selectors_1.length; _i++) {
        var selector = selectors_1[_i];
        var el = scope.querySelector(selector);
        if (el === null) {
            return null;
        }
        elements.push(el);
    }
    return cb.apply(void 0, elements);
}
